import { Box, Container, Divider, Grid, Theme } from "@mui/material"
import { makeStyles } from "@mui/styles"
import { FC, RefObject, useState } from 'react'
import { Animated } from "react-animated-css"
import useOnScreen from "../../../hooks/useOnScreen"
import Text from "../../common/Text"
import SectionTitle from "./SectionTitle"

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(19, 0),

        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(8, 0),
        },
        position: 'relative',
        zIndex: 9,
        // backgroundColor: '#fff'
        backgroundColor: theme.palette.custom.textPrimary,
    },
    heroTitle: {
        fontSize: 60,
        fontWeight: 700,
        lineHeight: '78px',
    },
    heroTitleHeading: {
        display: 'flex',
        alignItems: 'center',

        '&  .line': {
            width: 72,
            marginRight: 16,
            height: 1,
            backgroundColor: theme.palette.custom.textPrimary
        },
        '& .text': {
            fontSize: 20,
            textTransform: 'uppercase'
        }
    },
    grid: {
        paddingTop: theme.spacing(18.5),

        '& .number': {
            fontSize: 72,
            fontWeight: 600,
            lineHeight: '78px'
        },
        '& .step-title': {
            fontSize: 36,
            fontWeight: 500,
            marginBottom: 12
        },
        '& .step-desc': {
            fontSize: 16,
            lineHeight: '36px',
            opacity: 0.75
        },
        '& .divider': {
            margin: theme.spacing(8, 0)
        },


        [theme.breakpoints.down('md')]: {
            paddingTop: theme.spacing(8),

            '& .number': {
                fontSize: 36,
                fontWeight: 600,
                lineHeight: '36px'
            },
            '& .step-title': {
                fontSize: 24,
                fontWeight: 500,
                marginBottom: 8
            },
            '& .step-desc': {
                fontSize: 14,
                lineHeight: '28px'
            },
            '& .divider': {
                margin: theme.spacing(6, 0)
            },
        },
    }
    
}))

interface Props {
    innerRef: RefObject<HTMLElement>
}

const OurProcessSection: FC<Props> = ({
    innerRef
}) => {
    const classes = useStyles()
    const onScreen = useOnScreen(innerRef, "-180px");
    
    return (
        <Box ref={innerRef} className={`${classes.root} section_black`} component='section' id='ourProcessSection'>
            <Container>
                
                <Animated animationIn="fadeInUp" animationOut="fadeInUp" isVisible={onScreen} animateOnMount={false}>
                    <SectionTitle
                        headingTitle="OUR PROCESS"
                        titleLine1="Simple, yet effective "
                        titleLine2=""
                    />
                </Animated>
                {/* <Grid container className={classes.grid}>
                    <Grid item xs={12} md={5}>
                        <Animated animationIn="fadeIn" animationOut="fadeIn" isVisible={onScreen} animationInDelay={1000} animateOnMount={false}>
                            <Text className='number'>01</Text>
                        </Animated>
                    </Grid>
                    <Grid item xs={12} md={7}>
                        <Animated animationIn="fadeIn" animationOut="fadeIn" isVisible={onScreen} animationInDelay={1000} animateOnMount={false}>
                            <Text className='step-title'>Pre production</Text>
                            <Text className='step-desc'>Launch through all the planning, visioning of the project or to set the goals and depicts, kick start with PRORERAL ENTERTAINMENT. In the process, we’ll bind up your idea and will start weaving your vision with the script, demo and other pitches. Our creative team will work on your idea and execution together.</Text>
                        </Animated>
                    </Grid>
                    <Grid item xs={12} className='divider'>
                        <Animated animationIn="fadeIn" animationOut="fadeIn" isVisible={onScreen} animationInDelay={1000} animateOnMount={false}>
                            <Divider />
                        </Animated>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Animated animationIn="fadeIn" animationOut="fadeIn" isVisible={onScreen} animationInDelay={1500} animateOnMount={false}>
                            <Text className='number'>02</Text>
                        </Animated>
                    </Grid>
                    <Grid item xs={12} md={7}>

                        <Animated animationIn="fadeIn" animationOut="fadeIn" isVisible={onScreen} animationInDelay={1500} animateOnMount={false}>
                            <Text className='step-title'>Production</Text>
                            <Text className='step-desc'>All the raw data will be gathered by the shooting, and execution process will be done in this phase. PROREAL will help you setting the schedule and shoot upon it. In this phase we’ll capture the clips, shots according to your script/storyboard as per your call sheet and process the heart of your project.</Text>
                        </Animated>
                    </Grid>
                    <Grid item xs={12} className='divider'>
                        <Animated animationIn="fadeIn" animationOut="fadeIn" isVisible={onScreen} animationInDelay={1500} animateOnMount={false}>
                            <Divider />
                        </Animated>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Animated animationIn="fadeIn" animationOut="fadeIn" isVisible={onScreen} animationInDelay={2000} animateOnMount={false}>
                            <Text className='number'>03</Text>
                        </Animated>
                    </Grid>
                    <Grid item xs={12} md={7}>
                        <Animated animationIn="fadeIn" animationOut="fadeIn" isVisible={onScreen} animationInDelay={2000} animateOnMount={false}>
                            <Text className='step-title'>Post production</Text>
                            <Text className='step-desc'>The creative magic happens here. Our professional editing and VFX team will enhance your previously shot clips, audio with the graphics, manage and fix the errors, extras and all others which reflect on the final product to be the perfect one. Only after your approval for the video edit, we’ll deliver the final product and commemorate another shine with you.</Text>
                        </Animated>
                    </Grid>
                </Grid> */}

                <div className="new_process_wrapper">
                    <div className="section">
                        <h2>Movie Monetization</h2>
                        <p>Are you prepared to start generating income from your movie? Proreal services for monetizing movies can be useful. We specialize in assisting producers and distributors in making the most of their material through a range of distribution methods, such as FAST channels, video-on-demand, and streaming services. Our skilled staff will collaborate with you to develop a special monetization plan that will increase the income and visibility of your film. We'll take care of every step of the monetization process, from contract negotiations to revenue collection.</p>
                    </div>
                    <div className="section">
                        <h2>Film Distribution</h2>
                        <p>Proreal can help your movies reach a larger audience with our film distribution services! We specialize in gaining distribution rights and making sure the greatest number of people can watch your film. We manage every step of the distribution process, dealing with everything from logistics management to marketing your movie to negotiating contracts with exhibitors.</p>
                    </div>
                    <div className="section">
                        <h2>Photo and Video production</h2>
                        <p>If you are looking to produce top-notch image and video material for your project or brand, we can help with your photo and video production needs! Proreal expertises in creating aesthetically stunning material that draws in your audience and advances your objectives. To produce material that accurately represents your business and message, you will work directly with our skilled team of photographers, videographers, and editors. Everything is handled by us, including concept development, production, delivery, and post-production. We can meet your needs for corporate movies, product photography, or social media material</p>
                    </div>
                    <div className="section">
                        <h2>Line Production</h2>
                        <p>Proreal focuses in offering first-rate line manufacturing services to support you in realizing your idea. Everything is taken care of, including scheduling, logistics, and vendor management. In order to guarantee that your project is finished on time and within budget, our knowledgeable staff collaborates closely with you. We can help you whether you're doing a movie, TV show, commercial, or music video.</p>
                    </div>
                    <div className="section">
                        <h2>Co-Production</h2>
                        <p>Proreal specializes in collaborating with partners to provide top-notch content that addresses your particular needs. From concept creation and finance to production and post-production, our skilled team can assist you. To guarantee that your idea is fulfilled and the end result matches your requirements, we'll work directly with you. We can support you whether you're doing a movie, TV show, or online series.</p>
                    </div>
                    <div className="section">
                        <h2>Photography</h2>
                        <p>At Proreal we help creating images that are visually compelling and goes with the narrative. Our talented and experienced photographers are committed to capturing the spirit of your precious moments and producing timeless memories that you'll cherish for years to come. We have you covered whether you need a photographer business event, fashion or movie production. We will provide top-notch, expert images that go above and beyond your expectations thanks to our cutting-edge tools and creative vision.</p>
                    </div>
                    <div className="section">
                        <h2>Graphics Designing</h2>
                        <p> Looking for high-quality graphics to distinguish your brand? Look nowhere else! Proreal provides first-rate graphic design services that can advance your visual communication. You may develop gorgeous logos, brochures, flyers, business cards, and more with the assistance of our talented designers. We are committed to offering premium designs that flawlessly convey the personality and message of your brand and content.</p>
                    </div>
                    
                </div>
            </Container>
        </Box>
    )
}

export default OurProcessSection